"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingIndicatorScreenReaderTextMap = void 0;
exports.loadingIndicatorScreenReaderTextMap = {
    'en-US': 'Loading...',
    'en-AU': 'Loading...',
    'en-NZ': 'Loading...',
    'en-SG': 'Loading...',
    'en-GB': 'Loading...',
    'fr-FR': 'Chargement...',
    'en-FR': 'Loading...',
    'es-FR': 'Cargando...',
    'en-CA': 'Loading...',
    'fr-CA': 'Chargement...',
    'en-HK': 'Loading...',
    'zh-Hant-TW': '正在加載...',
    'zh-Hant-HK': '正在加載...',
    'de-DE': 'Wird geladen...',
    'en-DE': 'Loading...',
    'ja-JP': '読み込み中...',
    'ko-KR': '로딩 중...',
    'it-IT': 'Caricamento in corso...',
    'en-DK': 'Loading...',
    'en-SE': 'Loading...',
    'en-NO': 'Loading...',
    'de-CH': 'Wird geladen...',
    'fr-CH': 'Chargement...',
    'en-CH': 'Loading...',
};
//# sourceMappingURL=loading-indicator.js.map